import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import './ContactForm.css';

const SERVICE_ID = 'service_foc5lrg'; // Substitua pelo seu service_id do EmailJS
const TEMPLATE_ID = 'template_zutlsaz'; // Substitua pelo seu template_id do EmailJS
const USER_ID = '5bk9zWUsak22CDzq4'; // Substitua pelo seu public key do EmailJS

const ContactForm = () => {
  const form = useRef();
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const sendEmail = (e) => {
    e.preventDefault();
    setError('');
    emailjs.sendForm(SERVICE_ID, TEMPLATE_ID, form.current, USER_ID)
      .then(() => {
        setSent(true);
        form.current.reset();
      }, (err) => {
        setError('Erro ao enviar mensagem. Tente novamente.');
      });
  };

  return (
    <section className="contact-section">
      <h2>Entre em Contato</h2>
      <form ref={form} onSubmit={sendEmail} className="contact-form">
        <input type="text" name="user_name" placeholder="Seu nome" required />
        <input type="email" name="user_email" placeholder="Seu e-mail" required />
        <textarea name="message" placeholder="Sua mensagem" required rows={5} />
        <button type="submit">Enviar</button>
        {sent && <span className="success-msg">Mensagem enviada com sucesso!</span>}
        {error && <span className="error-msg">{error}</span>}
      </form>
    </section>
  );
};

export default ContactForm;
